import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, SkeletonContent, SkeletonLine
} from '@one-thd/sui-atomic-components';

export const EmptyThumbnails = ({ numberOfThumbnails }) => (
  <div className="sui-flex sui-flex-nowrap sui-gap-2 sui-overflow-x-hidden">
    {Array.from({ length: numberOfThumbnails }, (_value, thumbnailIndex) => thumbnailIndex).map((thumbnailId) => (
      <div
        key={`empty-box-${thumbnailId}`}
        data-testid={`list-image-empty-${thumbnailId}`}
        className="sui-shrink-0"
      >
        <div className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-bg-strong" />
      </div>
    ))}
  </div>
);

EmptyThumbnails.propTypes = {
  numberOfThumbnails: PropTypes.number.isRequired
};

const ListTilePlaceholder = ({ numberOfThumbnails = 3, maxWidth }) => {
  // Map maxWidth values to ensure classes are not purged
  const maxWidthClass = {
    'xs': 'sui-max-w-xs',
    'sm': 'sui-max-w-sm',
    'md': 'sui-max-w-md',
    'lg': 'sui-max-w-lg',
    'xl': 'sui-max-w-xl',
    '2xl': 'sui-max-w-2xl'
  }[maxWidth] || '';

  return (
    <Card
      data-component="ListTilePlaceholder"
      data-testid="lists-details-placeholder"
      className={`sui-w-full ${maxWidthClass}`}
    >
      <SkeletonContent density="loose" disablePadding initialSize="full">
        <SkeletonLine fullWidth variant="multi" numberOfLines={2} />
      </SkeletonContent>
      <CardBody>
        <EmptyThumbnails numberOfThumbnails={numberOfThumbnails + 1} />
      </CardBody>
    </Card>
  );
};

ListTilePlaceholder.displayName = 'ListTilePlaceholder';

ListTilePlaceholder.propTypes = {
  numberOfThumbnails: PropTypes.number,
  maxWidth: PropTypes.string
};

ListTilePlaceholder.defaultProps = {
  numberOfThumbnails: 3,
  maxWidth: null
};

export default ListTilePlaceholder;